import React from 'react';
import {Container, ExternalLink, Row, WhiteTypography} from './FooterSharedStyles';

type configType = {icon: string; link: string; name: string};

const config: configType[] = [
  {
    icon: '/social/f-icon.svg',
    link: 'https://www.facebook.com/FuPaNet/',
    name: 'Facebook',
  },
  {
    icon: '/social/ig-icon.svg',
    link: 'https://www.instagram.com/fupanet/',
    name: 'Instagram',
  },
  {
    icon: '/social/wa-icon.svg',
    link: 'https://wa.me/4915730181578',
    name: 'WhatsApp',
  },
  {
    icon: '/social/tiktok-icon.svg',
    link: 'https://www.tiktok.com/@fupanet',
    name: 'TikTok',
  },
  {
    icon: '/social/yt-icon.svg',
    link: 'https://www.youtube.com/user/FuPa2006',
    name: 'YouTube',
  },
];

const SocialMediaLinks = () => {
  return (
    <Container>
      <WhiteTypography variant='subheading2' component='span'>
        Folge uns
      </WhiteTypography>
      <Row>
        {config.map((elem: configType) => (
          <ExternalLink key={elem.name} href={elem.link} target='_blank'>
            <img src={elem.icon} alt={`Besuche unseren ${elem.name} Account`} />
          </ExternalLink>
        ))}
      </Row>
    </Container>
  );
};

export default SocialMediaLinks;
